import { Status } from '../constants/status';

export const rentalRelatedStatuses = [
  'rented',
  'returning_r',
  'returning_with_complaint_r',
  'returned_damaged_r',
  'returned_r',
  'in_repair_r',
  'in_cleaning_r',
  'shipped_c',
];

export const isRentalRelatedStatuse = (status) => {
  return (
    rentalRelatedStatuses.includes(status.toLowerCase()) ||
    status.toLowerCase().endsWith('_r')
  );
};

export const getStatusPillStyle = (status) => {
  switch (status) {
    case Status.in_transit:
      return {
        backgroundColor: 'rgba(160,91,78, 0.5)',
        color: '#2E2B2B',
      };
    case Status.listed:
      return {
        backgroundColor: 'rgba(122,140,138, 0.5)',
        color: '#2E2B2B',
      };
    case Status.rented:
      return { backgroundColor: '#EAD8D6', color: '#2E2B2B' };
    case Status.rejected1_c:
    case Status.rejected2_c:
      return {
        backgroundColor: 'rgba(200,141,120, 0.5)',
        color: '#2E2B2B',
      };
    case Status.draft_by_lender:
    case Status.draft:
      return { backgroundColor: '#c1d4d7', color: '#2E2B2B' };
    case Status.approved1_c:
      return { backgroundColor: '#faedc0', color: '#2E2B2B' };
    case Status.for_donation:
      return {
        backgroundColor: 'rgba(90,136,138, 0.5)',
        color: '#2E2B2B',
      };
    case Status.claimed_c:
      return {
        backgroundColor: 'rgba(219,200,189, 0.5)',
        color: '#2E2B2B',
      };
    case Status.pending_approval:
      return { backgroundColor: '#eae08c', color: '#2E2B2B' };
    case Status.needs_repair:
      return {
        backgroundColor: 'rgba(168,128,99, 0.5)',
        color: '#2E2B2B',
      };
    case Status.returned_c:
      return { backgroundColor: '#5a888a', color: '#FDF3E9' };
    case Status.returning_with_complaint:
    case Status.returning_c:
    case Status.returning_r:
    case Status.fit_returning_r:
      return { backgroundColor: '#c68d78', color: '#FDF3E9' };
    case Status.purchased:
      return { backgroundColor: '#7a8c8a', color: '#FDF3E9' };
    case Status.rental_delivered:
    case Status.rental_delivered_1:
      return { backgroundColor: '#a05b4e', color: '#FDF3E9' };
    default:
      return { backgroundColor: '#a05b4e', color: '#FDF3E9' };
  }
};
